import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=f200c284&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=js"
export * from "./dialog.vue?vue&type=script&lang=js"
import style0 from "./dialog.vue?vue&type=style&index=0&id=f200c284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f200c284",
  null
  
)

export default component.exports